import { IBuildTaskNameProps } from '../types/BuildTaskName';

function buildTaskName({ firm, contragent, project }: IBuildTaskNameProps): string {
    const firmName = firm?.value ? `${firm.value} - ` : '';
    const contragentName = contragent?.value ? `${contragent.value} - ` : '';
    const projectName = project?.value ?? '';

    return `${contragentName}${firmName}${projectName}`;
}

export default buildTaskName;
